import type { StepMode } from '../lib/debug/types';

interface Props {
	paused: boolean;
	playing: boolean;
	delay: number;
	line?: number;
	onStep: (mode: StepMode) => void;
	onPlay: () => void;
	onPause: () => void;
	onDelay: (delay: number) => void;
}

export function DebugControls({
	paused,
	playing,
	delay,
	line,
	onStep,
	onPlay,
	onPause,
	onDelay,
}: Props) {
	return (
		<div className="debug-controls" role="toolbar" aria-label="Debugger controls">
			<button
				type="button"
				disabled={!paused || playing}
				onClick={() => onStep('into')}
				title="Advance to the next source checkpoint"
			>
				Step into
			</button>
			<button type="button" disabled={!paused || playing} onClick={() => onStep('over')}>
				Step over
			</button>
			<button type="button" disabled={!paused || playing} onClick={() => onStep('out')}>
				Step out
			</button>
			<button type="button" disabled={!paused || playing} onClick={() => onStep('continue')}>
				Continue
			</button>
			<button type="button" disabled={!paused || playing} onClick={onPlay}>
				Slow play
			</button>
			<button type="button" disabled={paused && !playing} onClick={onPause}>
				Pause
			</button>
			<label>
				Step delay
				<select
					aria-label="Step delay"
					value={delay}
					onChange={(e) => onDelay(Number(e.target.value))}
				>
					<option value={100}>0.1 s</option>
					<option value={250}>0.25 s</option>
					<option value={500}>0.5 s</option>
					<option value={1000}>1 s</option>
					<option value={2000}>2 s</option>
				</select>
			</label>
			<span className="muted">{paused ? `Before line ${line}` : 'Running to checkpoint…'}</span>
		</div>
	);
}
